/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Australian_EnglishInputs */

const en_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australian English`)
};

const fr_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anglais australien`)
};

const de_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Australisches Englisch`)
};

const it_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglese australiano`)
};

const ru_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`австралийский английский`)
};

const es_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inglés australiano`)
};

const zh_cn2_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`澳大利亚英语`)
};

const ja_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーストラリア英語`)
};

const hi_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑस्ट्रेलियाई अंग्रेज़ी`)
};

const pt_pt2_australian_english = /** @type {(inputs: Australian_EnglishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inglês australiano`)
};

/**
* | output |
* | --- |
* | "Australian English" |
*
* @param {Australian_EnglishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const australian_english = /** @type {((inputs?: Australian_EnglishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Australian_EnglishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_australian_english(inputs)
	if (locale === "de") return de_australian_english(inputs)
	if (locale === "it") return it_australian_english(inputs)
	if (locale === "ru") return ru_australian_english(inputs)
	if (locale === "es") return es_australian_english(inputs)
	if (locale === "zh-CN") return zh_cn2_australian_english(inputs)
	if (locale === "ja") return ja_australian_english(inputs)
	if (locale === "hi") return hi_australian_english(inputs)
	if (locale === "pt-PT") return pt_pt2_australian_english(inputs)
	return en_australian_english(inputs)
});